import { RefObject, useEffect, useMemo, useState } from 'react'

const DEFAULT_LIST_MAX_HEIGHT = 290

type UseListHeightArgs = {
  fieldRef: RefObject<HTMLElement>
  listLength: number
  listMaxHeight?: number
}

const useListHeight = ({
  fieldRef,
  listLength,
  listMaxHeight,
}: UseListHeightArgs) => {
  const [fieldHeight, setFieldHeight] = useState(0)

  useEffect(() => {
    const el = fieldRef.current
    if (!el) return
    setFieldHeight(el.getBoundingClientRect().height)
  }, [listLength])

  const listHeight = useMemo(() => {
    return listMaxHeight
      ? Math.max(0, listMaxHeight - fieldHeight)
      : DEFAULT_LIST_MAX_HEIGHT
  }, [fieldHeight, listMaxHeight])

  return listHeight
}

export default useListHeight
